export default "__VITE_ASSET__CmBYsGW4__"